import React from "react";
import styles from './index.module.css';

const Card = ({ icon, text, number }) => {
  return (
    <div className={styles.card}>
      <div className={styles.cardIcon}>
      <img src={icon} alt={text} className={styles.cardIconImage} />
      </div>
      <div className={styles.cardContent}>
        <p className={styles.cardText}>{text}</p>
        <h1 className={styles.cardNumber}>{number}</h1>
      </div>
    </div>
  );
};

export default Card;